import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  ClipboardList,
  MessageSquare,
  BarChart3,
  Settings,
  HeartPulse,
  CheckSquare,
  Mail,
  FileText,
  Stethoscope,
  Activity,
  BookOpen,
  Megaphone,
  Filter,
  TrendingUp,
  FlaskConical,
  Shield,
  Layers,
  Lightbulb,
  Database,
  // Link2, // Temporariamente não utilizado (Integração Tasy oculta)
  UserCog,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/contexts/AuthContext';

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Meus Dashboards', href: '/dashboards', icon: Layers },
  { name: 'Pacientes', href: '/patients', icon: Users },
  { name: 'Atendimentos', href: '/encounters', icon: Stethoscope },
  { name: 'Evoluções', href: '/clinical', icon: FileText },
  { name: 'Estratificação', href: '/risk', icon: Activity },
  { name: 'Linhas de Cuidado', href: '/care-lines', icon: HeartPulse },
  { name: 'Questionários', href: '/questionnaires', icon: ClipboardList },
  { name: 'Educação', href: '/education', icon: BookOpen },
  { name: 'Campanhas', href: '/campaigns', icon: Megaphone },
  { name: 'Funil', href: '/funnel', icon: Filter },
  { name: 'Demandas', href: '/demands', icon: MessageSquare },
  { name: 'Tarefas', href: '/tasks', icon: CheckSquare },
  { name: 'Mensagens', href: '/messages', icon: Mail },
  { name: 'Relatórios', href: '/reports', icon: BarChart3 },
];

const adminNavigation = [
  { name: 'Dashboard Executivo', href: '/executive', icon: TrendingUp },
  { name: 'Insights Comunicação', href: '/insights/communication', icon: Lightbulb },
  { name: 'Testes A/B', href: '/ab-tests', icon: FlaskConical },
  { name: 'Usuários', href: '/admin/users', icon: UserCog },
  { name: 'Integração BI', href: '/admin/bi', icon: Database },
  // { name: 'Integração Tasy', href: '/admin/tasy', icon: Link2 }, // Temporariamente oculto
  { name: 'LGPD', href: '/admin/lgpd', icon: Shield },
];

export function Sidebar() {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes('ADMIN');

  return (
    <aside className="hidden w-64 flex-shrink-0 border-r bg-card lg:block">
      <div className="flex h-full flex-col">
        {/* Logo */}
        <div className="flex h-16 items-center border-b px-4">
          <img src="/logo-ativacare.svg" alt="ativaCare" className="h-7" />
          <span className="ml-2 rounded bg-amber-500 px-1.5 py-0.5 text-[10px] font-bold text-white">
            DEMO
          </span>
        </div>

        {/* Navigation */}
        <nav className="flex-1 space-y-1 px-3 py-4 overflow-y-auto">
          {navigation.map((item) => (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-primary text-primary-foreground'
                    : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                )
              }
            >
              <item.icon className="h-5 w-5" />
              {item.name}
            </NavLink>
          ))}

          {/* Admin Section */}
          {isAdmin && (
            <>
              <div className="my-4 border-t pt-4">
                <span className="px-3 text-xs font-semibold uppercase text-muted-foreground">
                  Administração
                </span>
              </div>
              {adminNavigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                    )
                  }
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </NavLink>
              ))}
            </>
          )}
        </nav>

        {/* Footer */}
        <div className="border-t p-3">
          <NavLink
            to="/settings"
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            <Settings className="h-5 w-5" />
            Configurações
          </NavLink>
        </div>
      </div>
    </aside>
  );
}
